/**
 * Member-visible "Transaction charges" = convenience (platform) + gateway pass-through (member portion).
 * Sums existing fee-preview fields client-side; does not change API persistence.
 */
export function getMemberTransactionChargesTotal(feePreview) {
  const c = Number(feePreview?.convenience_fee_member_portion ?? 0);
  const g = Number(feePreview?.gateway_pass_through_member_portion ?? 0);
  if (!Number.isFinite(c) || !Number.isFinite(g)) {
    return 0;
  }
  return Math.round((c + g) * 100) / 100;
}
